@if (userDataStore.isLoaded()) {
  <app-section>
    <div class="mx-auto w-full max-w-7xl px-4 py-6 lg:px-6">
      <div class="flex mb-6">
        <app-arrow-link icon="arrow-left" title="Inicio" route="/portal/home"></app-arrow-link>
      </div>

      <div class="sticky top-3 z-30 mb-6 flex justify-end">
        <div
          class="w-full rounded-2xl border border-pae-grey-3 bg-white/95 px-4 py-3 shadow-md backdrop-blur md:w-auto md:min-w-72">
          <p class="text-[11px] font-semibold uppercase tracking-[0.28em] text-pae-purple-25">Shipto seleccionado</p>
          <p class="text-lg font-bold text-gray-900">{{ userDataStore.getNDestinatario() }}</p>
        </div>
      </div>

      <section
        class="rounded-3xl border border-pae-grey-3 bg-gradient-to-br from-white via-pae-white to-pae-grey-1 p-6 shadow-sm">
        <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.32em] text-pae-purple-25">Area privada</p>
            <h1 class="text-3xl font-bold text-gray-900">User debug</h1>
            <p class="mt-2 max-w-3xl text-sm text-gray-600">
              Vista interna para revisar el estado completo del store de usuario y cambiar de shipto sin restricciones.
            </p>
          </div>
        </div>
      </section>

      @if (isSubUser()) {
        <section class="mt-6 rounded-3xl border border-pae-grey-3 bg-pae-white p-6 shadow-sm">
          <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <p class="text-xs font-semibold uppercase tracking-[0.28em] text-pae-purple-25">Sub-usuario</p>
              <h2 class="mt-1 text-2xl font-bold text-gray-900">Roles asignados</h2>
              <p class="mt-2 text-sm text-gray-600">
                El rol informado por <span class="font-semibold">getSubUserRole</span> es:
              </p>
            </div>

            <div class="rounded-2xl border border-pae-grey-3 bg-pae-grey-1 px-5 py-4 text-right">
              <p class="text-[11px] font-semibold uppercase tracking-[0.24em] text-pae-purple-25">Rol actual</p>
              <p class="mt-1 text-lg font-bold text-gray-900">{{ subUserRoleName() }}</p>
            </div>
          </div>

          <div class="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            <div class="rounded-2xl border border-pae-grey-3 bg-pae-grey-1 px-4 py-3">
              <p class="text-[11px] font-semibold uppercase tracking-[0.24em] text-pae-purple-25">Asignadas</p>
              <p class="mt-1 text-2xl font-bold text-gray-900">{{ assignedRoleSections().length }}</p>
            </div>

            <div class="rounded-2xl border border-pae-grey-3 bg-pae-grey-1 px-4 py-3">
              <p class="text-[11px] font-semibold uppercase tracking-[0.24em] text-pae-purple-25">Total secciones</p>
              <p class="mt-1 text-2xl font-bold text-gray-900">{{ roleSections().length }}</p>
            </div>

            <div class="rounded-2xl border border-pae-grey-3 bg-pae-grey-1 px-4 py-3">
              <p class="text-[11px] font-semibold uppercase tracking-[0.24em] text-pae-purple-25">Fuente</p>
              <p class="mt-1 text-sm font-semibold text-gray-900">sections + SeccionesRolesEnum</p>
            </div>
          </div>

          <div class="mt-5">
            @if (assignedRoleSections().length > 0) {
              <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                @for (role of assignedRoleSections(); track role.section) {
                  <article class="rounded-2xl border border-pae-grey-3 bg-white p-4 shadow-sm">
                    <p class="text-[11px] font-semibold uppercase tracking-[0.18em] text-pae-purple-25">
                      {{ role.enumKey }}
                    </p>
                    <p class="mt-2 break-words text-sm font-semibold text-gray-900">{{ role.section }}</p>
                  </article>
                }
              </div>
            } @else {
              <div class="rounded-2xl border border-pae-grey-3 bg-pae-grey-1 p-4 text-sm text-gray-600">
                Este sub-usuario no tiene secciones habilitadas en el objeto
                <span class="font-semibold">sections</span>.
              </div>
            }
          </div>
        </section>
      }

      <app-session-page />
    </div>
  </app-section>
} @else {
  <div class="flex flex-col h-full w-full justify-center items-center fixed top-0 bottom-0">
    <app-loading-pae [text]="messageLoading()" />
  </div>
}
